/*
* @描述: 商机流程设置
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-12-04 09:24:44
*/
<template>
    <div class="page_container">
        <div class="page_header">
            <div class="flex_wrap">
                <div class="return_btn_wrap" @click="handleClickReturn">
                    <i class="el-icon-arrow-left"></i>
                    <span>返回</span>
                </div>
                <span class="line"></span>
                <span class="page_title" v-text="stepActive==='1'?'新建流程':'设置阶段任务'"></span>
            </div>
            <div v-if="stepActive==='2'">
                <el-button plain size="mini" type="primary" @click="handleClickStagePreview">预览</el-button>
                <el-button :disabled="btnDisabled" size="mini" type="primary" @click="handleClickStagePublish">发布
                </el-button>
            </div>
        </div>
        <div v-loading="loading" class="page_body">
            <div v-if="stepActive==='1'" class="business_flow_form_board">
                <div class="business_flow_form_wrap">
                    <el-form ref="businessGroupForm"
                             :model="businessGroupForm"
                             :rules="businessGroupFormRules"
                             label-position="top"
                             size="small">
                        <el-form-item label="商机分组名称" prop="name">
                            <el-input v-model="businessGroupForm.name"
                                      maxlength="10"
                                      @blur="handleGroupNameInputBlur"
                                      placeholder="请输入商机分组名称"></el-input>
                        </el-form-item>
                        <el-form-item v-if="businessGroupForm.is_system===0" prop="applicable_rules.rules">
                            <div slot="label" class="flex_js_wrap">
                                <div>
                                    <span>选择适用此流程的商机</span>
                                    <span>（不设置默认适用全部商机）</span>
                                </div>
                                <div>
                                    <span>符合以下：</span>
                                    <el-select v-model="businessGroupForm.applicable_rules.boolean"
                                               class="boolean_select" size="mini">
                                        <el-option label="所有" value="and"></el-option>
                                        <el-option label="任一" value="or"></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <ul class="flow_rules_list">
                                <li v-for="(rule,index) in businessGroupForm.applicable_rules.rules" :key="index"
                                    class="flow_rules_item">
                                    <div class="rule_field_wrap">
                                        <el-select v-model="rule.field_key"
                                                   placeholder="请选择作为规则的字段"
                                                   @focus="handleFieldSelectFocus">
                                            <el-option v-for="field in conditionFieldList"
                                                       :key="field.field_key"
                                                       :label="field.field_name"
                                                       :value="field.field_key"
                                                       @click.native="handleClickFieldItem(field,rule)">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="rule_operator_wrap">满足</div>
                                    <div class="rule_value_wrap">
                                        <div v-if="rule.field_key&&conditionFieldList[rule.field_key]">
                                            <el-select v-if="rule.field_type==='radio'||rule.field_type==='checkbox'"
                                                       v-model="rule.field_value"
                                                       :placeholder="'请选择' + rule.field_name"
                                                       collapse-tags
                                                       filterable
                                                       multiple
                                                       size="small"
                                                       @change="handleOptionSelectChange(rule)">
                                                <el-option v-for="option in conditionFieldList[rule.field_key].options"
                                                           :label="option.label"
                                                           :value="option.value">
                                                </el-option>
                                            </el-select>
                                            <el-select v-else-if="rule.field_type==='contact'"
                                                       v-model="rule.field_value"
                                                       :placeholder="'请选择' + rule.field_name"
                                                       :remote-method="getContactList"
                                                       clearable
                                                       collapse-tags
                                                       filterable
                                                       multiple
                                                       remote
                                                       size="small"
                                                       @clear="handleClickClearContact(rule)"
                                                       @remove-tag="handleRemoveContactTag(rule)">
                                                <el-option v-for="user in contactOptions"
                                                           :key="user.uid"
                                                           :label="user.name"
                                                           :value="user.uid"
                                                           @click.native="handleContactSelectChange(user,rule)">
                                                </el-option>
                                            </el-select>
                                            <el-select v-else-if="rule.field_type==='department'"
                                                       v-model="rule.field_text"
                                                       :placeholder="'请选择' + rule.field_name"
                                                       clearable
                                                       collapse-tags
                                                       multiple
                                                       size="small"
                                                       @clear="handleClickClearDepartment(rule,index)"
                                                       @remove-tag="handleRemoveDepartmentTag(rule,index)">
                                                <el-option :value="[]" style="height: auto;padding: 0">
                                                    <el-tree :ref="`dep_select_tree${index}`"
                                                             :data="departmentList"
                                                             :expand-on-click-node='false'
                                                             :props="{children: 'children',label: 'relate_name'}"
                                                             check-on-click-node
                                                             check-strictly
                                                             default-expand-all
                                                             highlight-current
                                                             node-key="relate_id"
                                                             show-checkbox
                                                             size="mini"
                                                             @check-change="(data,checked,indeterminate)=>handleDepartmentCheckChange(data,checked,indeterminate,rule)">
                                                    </el-tree>
                                                </el-option>
                                            </el-select>
                                            <div v-else-if="rule.field_type==='date'">
                                                <el-date-picker
                                                        v-if="conditionFieldList[rule.field_key].date_type==='daterange'"
                                                        v-model="rule.field_value"
                                                        :editable="false"
                                                        end-placeholder="结束日期"
                                                        format="yyyy/MM/dd"
                                                        range-separator="～"
                                                        size="small"
                                                        start-placeholder="开始日期"
                                                        type="daterange"
                                                        value-format="yyyy-MM-dd"
                                                        @change="handleDateSelectChange(rule)">
                                                </el-date-picker>
                                                <el-time-picker
                                                        v-else-if="conditionFieldList[rule.field_key].date_type==='timerange'"
                                                        v-model="rule.field_value"
                                                        end-placeholder="结束时间"
                                                        format="HH:mm"
                                                        is-range
                                                        range-separator="～"
                                                        size="small"
                                                        start-placeholder="开始时间"
                                                        value-format="HH:mm"
                                                        @change="handleDateSelectChange(rule)">
                                                </el-time-picker>
                                                <el-date-picker
                                                        v-else-if="conditionFieldList[rule.field_key].date_type === 'datetimerange'"
                                                        v-model="rule.field_value"
                                                        :editable="false"
                                                        end-placeholder="结束时间"
                                                        format="yyyy/MM/dd HH:mm"
                                                        range-separator="～"
                                                        size="small"
                                                        start-placeholder="开始时间"
                                                        type="datetimerange"
                                                        value-format="yyyy-MM-dd HH:mm"
                                                        @change="handleDateSelectChange(rule)">
                                                </el-date-picker>
                                                <el-date-picker
                                                        v-else-if="conditionFieldList[rule.field_key].date_type === 'monthrange'"
                                                        v-model="rule.field_value"
                                                        end-placeholder="结束月份"
                                                        format="yyyy/MM"
                                                        range-separator="～"
                                                        size="small"
                                                        start-placeholder="开始月份"
                                                        type="monthrange"
                                                        value-format="yyyy-MM"
                                                        @change="handleDateSelectChange(rule)">
                                                </el-date-picker>
                                            </div>
                                        </div>
                                        <el-input v-else placeholder="请选择作为规则的字段" readonly></el-input>
                                    </div>
                                    <div class="handle_icon_wrap handle_icon_danger_wrap"
                                         @click="handleClickDelCondition(index)">
                                        <i class="iconfont icon-shanchu1"></i>
                                    </div>
                                </li>
                            </ul>
                            <div class="add_condition_btn" @click="handleClickAddCondition"><i class="el-icon-plus"></i>添加条件
                            </div>
                        </el-form-item>
                        <el-form-item v-else label="选择适用此流程的商机">
                            <p class="default_hint">默认商机分组无需设置，默认为其他商机分组以外的全部商机</p>
                        </el-form-item>
                    </el-form>
                    <div class="business_flow_btn_wrap">
                        <el-button size="small" @click="handleClickReturn">取消</el-button>
                        <el-button size="small" type="primary" @click="handleClickNextStep">下一步</el-button>
                    </div>
                </div>
            </div>
            <div v-else class="stage_task_wrap">
                <div class="left_task_field_wrap">
                    <h2>任务选择区</h2>
                    <p class="title_desc">可拖拽至右侧添加为该阶段任务</p>
                    <div class="stage_task_field_wrap">
                        <h3>系统内置任务</h3>
                        <ul class="stage_task_field_list">
                            <draggable :animation="300"
                                       :group="{ name: 'stage_task_group', pull: 'clone', put: false }"
                                       :list="systemTaskList"
                                       :sort="false"
                                       filter=".drag_disabled"
                                       @end="onTaskFiledDragEnd">
                                <li v-for="field in systemTaskList"
                                    :class="{'drag_disabled':field.drag_disabled}"
                                    class="stage_task_field_item"
                                    data-from="system">
                                    <div class="field_name" v-text="field.field_name"></div>
                                    <div v-if="field.extend" class="tasks_desc" v-text="field.extend.tasks_desc"></div>
                                </li>
                            </draggable>
                        </ul>
                        <div class="flex_js_wrap">
                            <h3>自设阶段任务</h3>
                            <el-link :underline="false"
                                     icon="el-icon-plus"
                                     type="primary"
                                     @click="handleClickAddTask">添加任务
                            </el-link>
                        </div>
                        <ul class="stage_task_field_list">
                            <draggable :animation="300"
                                       :group="{ name: 'stage_task_group', pull: 'clone', put: false }"
                                       :list="customTaskList"
                                       :sort="false"
                                       filter=".drag_disabled"
                                       @end="onTaskFiledDragEnd"
                                       :move="onTaskFiledDragMove"
                                       chosenClass="chosen">
                                <li v-for="field in customTaskList"
                                    :class="{'drag_disabled':field.drag_disabled}"
                                    class="stage_task_field_item"
                                    data-from="custom">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                </div>
                <div class="right_stage_review_wrap">
                    <h2>阶段预览区</h2>
                    <p class="title_desc">
                        展示在各阶段及当前阶段推进至下一阶段时需填写的信息，按住可拖动排序字段及阶段位置</p>
                    <ul class="stage_list">
                        <draggable :animation="300"
                                   :list="businessGroupForm.project_stages"
                                   class="stage_list_drag_wrap">
                            <li v-for="(item,index) in businessGroupForm.project_stages" :key="index"
                                class="stage_item">
                                <div class="stage_title_wrap">
                                    <el-input v-if="item.stage_title_edit"
                                              :ref="`stage_title_input_${index}`"
                                              v-model="item.name"
                                              maxlength="10"
                                              placeholder="请输入阶段名称"
                                              size="mini"
                                              @blur="handleStageTitleInputBlur(item,index)"
                                              @keyup.enter.native="handleEnterStageTitleInput(index)">
                                    </el-input>
                                    <div v-else
                                         class="stage_title"
                                         @click="handleClickStageTitle(item,index)"
                                         v-text="item.name"></div>
                                    <div class="stage_handle_icon_wrap">
                                        <el-tooltip v-if="businessGroupForm.project_stages.length<9"
                                                    effect="dark"
                                                    content="添加阶段"
                                                    placement="top">
                                            <div class="handle_icon_wrap" @click="handleClickAddStage(index)">
                                                <i class="el-icon-circle-plus"></i>
                                            </div>
                                        </el-tooltip>
                                        <el-tooltip v-if="index>0" content="删除阶段" effect="dark" placement="top">
                                            <div class="handle_icon_wrap" @click="handleClickDelStage(item,index)">
                                                <i class="el-icon-remove"></i>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <ul class="stage_task_list">
                                    <draggable :animation="300"
                                               :list="item.tasks"
                                               class="stage_task_drag_wrap"
                                               :ref="'stage_task_drag_wrap_'+index"
                                               group="stage_task_group"
                                               ghostClass="stage_task_drag_move"
                                               handle=".stage_task_item">
                                        <template v-if="item.tasks.length">
                                            <li v-for="field in item.tasks"
                                                :key="item.field_key"
                                                class="stage_task_item">
                                                <div class="field_name" v-text="field.field_name"></div>
                                                <el-checkbox v-model="field.is_required"
                                                             :false-label="0"
                                                             :true-label="1">必填
                                                </el-checkbox>
                                                <i class="el-icon-remove"
                                                   @click="handleClickDelStageTask(item,field)"></i>
                                            </li>
                                        </template>
                                        <div v-else class="stage_empty_wrap">
                                            <i class="iconfont icon-weizhi3"></i>
                                            <p>可将左侧需填写的字段拖入添加到此区域</p>
                                        </div>
                                    </draggable>
                                </ul>
                            </li>
                            <li class="last_empty_item">
                                <div class="top"></div>
                                <div class="bottom"></div>
                            </li>
                        </draggable>
                    </ul>
                </div>
            </div>
        </div>
        <el-dialog v-if="reviewDetailDialog"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :show-close="false"
                   :visible.sync="reviewDetailDialog"
                   custom-class="review_form_dialog"
                   title=""
                   width="1120px">
            <div class="review_form_wrap">
                <i class="el-icon-close" @click="handleClickCloseReviewFormDialog"></i>
                <ul class="review_form_type_list">
                    <li v-for="item in reviewTypeList"
                        :class="{'active':reviewFormType===item.value}"
                        class="review_form_type_item"
                        @click="handleClickReviewFormType(item)"
                        v-text="item.label">
                    </li>
                </ul>
                <div v-if="reviewFormType==='pc'" class="pc_review_wrap">
                    <div class="business_stage_detail">
                        <div class="page_little_title"><span class="title">商机阶段</span></div>
                        <div class="business_stage_wrap">
                            <ul class="business_stage_list">
                                <li v-for="(item,index) in businessGroupForm.project_stages"
                                    :class="{'excessive_current_stage':currentStage>=index,'current_stage':currentStage===index}"
                                    class="business_stage_item"
                                    @click="handleClickStageItem(item,index)">
                                    <div class="stage_index" v-text="index+1"></div>
                                    <el-tooltip v-if="index>currentStage"
                                                content="推进至此阶段"
                                                effect="dark"
                                                placement="top">
                                        <div class="stage_title" v-text="item.name"></div>
                                    </el-tooltip>
                                    <div v-else class="stage_title" v-text="item.name"></div>
                                    <i class="el-icon-arrow-right"></i>
                                </li>
                                <el-dropdown trigger="click">
                                    <li class="business_stage_item business_end_stage">
                                        <div class="stage_index"
                                             v-text="businessGroupForm.project_stages.length+1"></div>
                                        <el-tooltip content="推进至此阶段"
                                                    effect="dark"
                                                    placement="top">
                                            <div class="stage_title">结束<i class="el-icon-caret-bottom"></i></div>
                                        </el-tooltip>
                                    </li>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="handleClickBusinessStageEnd"><i
                                                class="iconfont icon-xiao"></i>赢单
                                        </el-dropdown-item>
                                        <el-dropdown-item @click.native="handleClickBusinessStageEnd"><i
                                                class="iconfont icon-ku"></i>输单
                                        </el-dropdown-item>
                                        <el-dropdown-item @click.native="handleClickBusinessStageEnd"><i
                                                class="iconfont icon-wunai"></i>无效商机
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </ul>
                            <el-button v-if="currentStage<businessGroupForm.project_stages.length-1"
                                       size="mini"
                                       type="primary"
                                       @click="handleClickAdvanceNextStage">推进下一阶段
                            </el-button>
                        </div>
                        <div v-if="stageTaskFieldList.length" class="page_little_title"><span
                                class="title">阶段任务</span>
                        </div>
                        <div class="stage_task_form_wrap">
                            <div v-if="stageTaskFieldList.length" class="custom_form_body">
                                <CustomFormPc v-if="stageTaskFieldFormShow"
                                              key="pc"
                                              :field_list="stageTaskFieldList"
                                              :is_form_module="true"
                                              :is_preview_mode="true"/>
                                <CustomFormPc v-if="projectStageFormShow"
                                              ref="projectStageForm"
                                              :field_list="projectStageFormFields">
                                </CustomFormPc>
                            </div>
                            <div v-else class="no_task_hint">当前阶段暂无任务</div>
                        </div>
                    </div>
                </div>
                <div v-else-if="reviewFormType==='mobile'" class="mobile_review_outer_wrap">
                    <div class="mobile_review_inner_wrap">
                        <div class="business_stage_detail">
                            <div class="review_form_title">
                                <i class="el-icon-arrow-left"></i>
                                <span>商机阶段</span>
                            </div>
                            <div class="business_stage_list_wrap">
                                <ul class="business_stage_list">
                                    <li v-for="(item,index) in businessGroupForm.project_stages"
                                        :class="{'current_stage':currentStage>=index}"
                                        class="business_stage_item"
                                        @click="handleClickStageItem(item,index)"
                                        v-text="index+1">
                                    </li>
                                </ul>
                            </div>
                            <div class="business_stage_wrap">
                                <div>
                                    <span class="current_stage_index" v-text="currentStage+1"></span>
                                    <span class="stage_list_length"
                                          v-text="'/'+businessGroupForm.project_stages.length"></span>
                                    <span class="current_stage_title"
                                          v-text="businessGroupForm.project_stages[currentStage].name"></span>
                                </div>
                                <el-button size="mini" type="primary" @click="handleClickAdvanceNextStage">推进阶段
                                </el-button>
                            </div>
                            <div v-if="stageTaskFieldList.length" class="title_wrap">
                                <div class="page_little_title">
                                    <span class="title">阶段任务</span>
                                </div>
                            </div>
                            <div class="stage_task_form_wrap">
                                <div v-if="stageTaskFieldList.length">
                                    <CustomFormMobile v-if="stageTaskFieldFormShow"
                                                      :field_list="stageTaskFieldList"
                                                      :is_form_module="true"
                                                      :is_preview_mode="true"/>
                                </div>
                                <div v-else class="no_task_hint">当前阶段暂无任务</div>
                            </div>
                        </div>
                        <div class="mobile_handle_line"></div>
                    </div>
                </div>
                <p class="form_desc">
                    模拟真实商机详情中各阶段任务，点击各阶段切换查看，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作</p>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    GetDepartmentList,
    getFormFields,
    GetUserList,
    projectGroupAdd,
    projectGroupDetail,
    projectGroupEdit,
} from "@/api";
import draggable from 'vuedraggable'
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
import {EventBus} from "@/utils/eventBus";

export default {
    name: "businessFlowSet",
    data() {
        return {
            loading: false,
            stepActive: '1',
            businessGroupForm: {
                name: '',
                project_group_id: this.$route.query.id || 0,
                applicable_rules: {
                    boolean: 'and',
                    rules: [{
                        type: 'field',
                        operator: '=',
                        field_key: '',
                        field_name: '',
                        field_type: '',
                        field_text: [],
                        field_value: [],
                    }]
                },
                project_stages: [{
                    name: "",
                    tasks: [],
                    stage_title_edit: true
                }],
                is_system: 0
            },
            businessGroupFormRules: {
                name: [{required: true, message: '请输入商机分组名称', trigger: 'blur'}],
                "applicable_rules.rules": [{
                    required: false,
                    validator(rule, value, callback) {
                        if (value.length === 0) {
                            callback()
                        } else {
                            if (value.some(item => item.field_key === '')) {
                                callback(new Error('请将规则完善或者删除'))
                            } else {
                                callback()
                            }
                        }
                    },
                }]
            },
            conditionFieldList: {},
            departmentList: [],
            contactOptions: [],
            systemTaskList: [],//系统内置任务
            customTaskList: [],//自设阶段任务
            reviewDetailDialog: false,
            reviewFormType: 'pc',
            reviewTypeList: [
                {
                    value: 'pc',
                    label: '电脑端'
                },
                {
                    value: 'mobile',
                    label: '移动端'
                },
            ],
            currentStage: 0,
            stageTaskFieldList: [],
            stageTaskFieldFormShow: true,
            hasEdit: false,
            btnDisabled: false,
            uids: []
        }
    },
    components: {draggable, CustomFormPc, CustomFormMobile},
    created() {
        if (this.businessGroupForm.project_group_id) {
            this.getBusinessGroupDetail()
        }
    },
    mounted() {
    },
    methods: {
        //表单字段获取
        _getFromFields() {
            getFormFields({
                field_form: 'projects'
            }).then(res => {
                if (res.code === 200) {
                    this.conditionFieldList = {}
                    res.data.forEach(field => {
                        if (field.is_system === 0) {
                            const item = {
                                ...field,
                                ...field.extend
                            }
                            delete item.extend
                            if (item.field_type === 'radio' || item.field_type === 'checkbox') {
                                this.$set(this.conditionFieldList, item.field_key, item)
                            } else if (item.field_type === 'date') {
                                if (item.date_type === 'year-month') {
                                    item.date_type = 'monthrange'
                                } else {
                                    item.date_type = item.date_type + 'range'
                                }
                                if (item.date_type === 'timerange') {
                                    item.field_value = [new Date(2025, 1, 1, 9, 0), new Date(2025, 1, 1, 18, 0)]
                                }
                                this.$set(this.conditionFieldList, item.field_key, item)
                            } else if (item.field_type === 'department') {
                                this.$set(this.conditionFieldList, item.field_key, item)
                            } else if (item.field_type === 'contact') {
                                this.$set(this.conditionFieldList, item.field_key, item)
                            }
                        }
                    })
                } else {

                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },

        //点击返回
        handleClickReturn() {
            if (this.stepActive === '1') {
                if (this.hasEdit) {
                    this.$msgbox({
                        title: '您本次编辑内容还未发布！',
                        message: '直接退出将不会保存本次编辑内容，是否确认退出',
                        confirmButtonText: '退出',
                        cancelButtonText: '取消',
                        confirmButtonClass: 'el-button--danger',
                        iconClass: 'iconfont icon-shuoming',
                        showCancelButton: true,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        customClass: 'icon_title_message_box icon_title_message_box_danger'
                    }).then(() => {
                        this.$router.replace({
                            name: 'BusinessManagement',
                            params: {
                                from: 'set'
                            }
                        })
                    }).catch(() => {

                    })
                } else {
                    this.$router.replace({
                        name: 'BusinessManagement',
                        params: {
                            from: 'set'
                        }
                    })
                }
            } else {
                this.stepActive = '1'
            }
        },

        //获取商机组详情
        getBusinessGroupDetail() {
            this.loading = true
            projectGroupDetail({
                project_group_id: this.businessGroupForm.project_group_id
            }).then(res => {
                if (res.code === 200) {
                    this.businessGroupForm.name = res.data.name
                    this.businessGroupForm.applicable_rules.boolean = res.data.applicable_rules.boolean
                    if (res.data.applicable_rules.rules && res.data.applicable_rules.rules.length) {
                        this.loading = true
                        this._getFromFields()
                        this.businessGroupForm.applicable_rules.rules = res.data.applicable_rules.rules
                        this.uids = res.data.applicable_rules.rules.map(rules => rules.field_value).flat()
                        this.getContactList()
                    } else {
                        this.loading = false
                    }
                    this.businessGroupForm.is_system = res.data.is_system
                    this.businessGroupForm.project_stages = res.data.project_stages
                } else {

                    this.loading = false
                }
            })
        },

        //点击添加条件
        handleClickAddCondition() {
            this.businessGroupForm.applicable_rules.rules.push({
                type: 'field',
                operator: '=',
                field_key: '',
                field_name: '',
                field_type: '',
                field_text: [],
                field_value: [],
            })
            this.hasEdit = true
        },

        //名称输入框事件事件
        handleGroupNameInputBlur() {
            if (this.businessGroupForm.name.trim() !== '') {
                this.hasEdit = true
            }
        },

        //条件字段选择框聚焦事件
        handleFieldSelectFocus() {
            if (Object.keys(this.conditionFieldList).length === 0) {
                this._getFromFields()
            }
        },

        //点击选择条件字段
        handleClickFieldItem(field, rule) {
            rule.field_key = field.field_key
            rule.field_name = field.field_name
            rule.field_type = field.field_type
            rule.field_text = []
            rule.field_value = []
            this.hasEdit = true
            if (field.field_type === 'department') {
                if (this.departmentList.length === 0) {
                    this.getDepartmentList()
                }
            } else if (field.field_type === 'contact') {
                if (this.contactOptions.length === 0) {
                    this.getContactList()
                }
            } else if (field.field_type === 'date') {
                if (field.date_type === 'timerange') {
                    rule.field_value = [new Date(2025, 1, 1, 9, 0), new Date(2025, 1, 1, 18, 0)]
                    rule.field_text = rule.field_value.join('～')
                }
            }
        },

        //选择类型条件选择事件
        handleOptionSelectChange(rule) {
            const options = this.conditionFieldList[rule.field_key].options
            rule.field_text = options.filter(item => rule.field_value.includes(item.value)).map(item => item.label);
        },

        //获取联系人列表
        getContactList(keyword) {
            GetUserList({
                keyword,
                uids: this.uids
            }).then(res => {
                if (res.code === 200) {
                    this.contactOptions = res.data || []
                } else {
                    this.$toast(res.message)
                }
            })
        },

        //获取部门列表
        getDepartmentList() {
            GetDepartmentList().then(res => {
                if (res.code === 200) {
                    this.departmentList = res.data || []
                } else {

                }
            })
        },

        //选择联系人类型条件
        handleContactSelectChange(user, rule) {
            if (rule.field_value.includes(user.uid)) {
                rule.field_text.push(user.name)
            } else {
                rule.field_text.splice(rule.field_value.indexOf(user.uid), 1)
            }
        },

        //删除联系人标签
        handleRemoveContactTag(rule) {
            rule.field_text.shift()
        },

        //清除联系人
        handleClickClearContact(rule) {
            rule.field_value = []
            rule.field_text = []
        },

        //部门选择事件
        handleDepartmentCheckChange(data, checked, indeterminate, rule) {
            if (checked) {
                rule.field_text.push(data.relate_name)
                rule.field_value.push(data.relate_id)
            } else {
                const index = rule.field_value.indexOf(data.relate_id)
                rule.field_text.splice(index, 1)
                rule.field_value.splice(index, 1)
            }
        },

        //删除部门标签
        handleRemoveDepartmentTag(rule, index) {
            rule.field_value.shift()
            const keys = rule.field_value.map(item => item)
            this.$refs[`dep_select_tree${index}`][0].setCheckedKeys([])
            this.$nextTick(() => {
                this.$refs[`dep_select_tree${index}`][0].setCheckedKeys(keys)
            })
        },

        //清除部门选择
        handleClickClearDepartment(rule, index) {
            rule.field_value = []
            rule.field_text = []
            this.$refs[`dep_select_tree${index}`][0].setCheckedKeys([])
        },

        //选择日期组件事件
        handleDateSelectChange(rule) {
            if (!rule.field_value) {
                rule.field_value = []
            }
            rule.field_text = rule.field_value.join('～')
        },

        //点击删除条件
        handleClickDelCondition(index) {
            this.businessGroupForm.applicable_rules.rules.splice(index, 1)
            this.hasEdit = true
            this.$refs.businessGroupForm.validateField('applicable_rules.rules')
        },

        //点击取消
        handleClickCancel() {
            this.$router.back()
        },

        //点击下一步
        handleClickNextStep() {
            this.$refs.businessGroupForm.validate(valid => {
                if (valid) {
                    this.stepActive = '2';
                    if (this.systemTaskList.length === 0 || this.customTaskList.length === 0) {
                        this.getTaskFieldList()
                    }
                } else {
                    this.$message.error('请输入商机分组名称');
                }
            })
        },

        //获取任务字段列表
        getTaskFieldList() {
            this.loading = true
            getFormFields({
                field_form: 'project_stage_tasks'
            }).then(res => {
                if (res.code === 200) {
                    if (this.businessGroupForm.project_group_id && this.businessGroupForm.project_stages.some(item => item.tasks.length)) {
                        res.data.forEach(field => {
                            this.$set(field, 'drag_disabled', this.isFieldKeyExist(field.field_key))
                        })
                    }
                    this.systemTaskList = res.data.filter(item => item.is_system === 1)
                    this.customTaskList = res.data.filter(item => item.is_system !== 1)
                } else {

                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },

        isFieldKeyExist(fieldKey) {
            return this.businessGroupForm.project_stages.some(item => {
                if (item.tasks) {
                    return item.tasks.some(task => task.field_key === fieldKey);
                }
                return false;
            });
        },

        //点击添加任务
        handleClickAddTask() {
            this.$router.push({
                name: "businessFormSet",
                query: {type: 'project_stage_tasks'}
            })
        },

        //点击添加阶段
        handleClickAddStage(index) {
            const start = index + 1
            this.businessGroupForm.project_stages.splice(start, 0, {
                stage_title: '',
                tasks: [],
                stage_title_edit: true,
            })
            this.hasEdit = true
        },

        //点击删除阶段
        handleClickDelStage(stage, index) {
            if (stage.project_stage_id) {
                this.$msgbox({
                    title: '确认删除该阶段？',
                    message: '删除后，位于该阶段的商机将退回至上一阶段',
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    confirmButtonClass: 'el-button--danger',
                    iconClass: 'iconfont icon-bangzhuzhongxin',
                    showCancelButton: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    customClass: 'icon_title_message_box icon_title_message_box_danger'
                }).then(() => {
                    this.delStageMethods(stage, index)
                }).catch(() => {

                });
            } else {
                this.delStageMethods(stage, index)
            }
        },

        //删除阶段方法
        delStageMethods(stage, index) {
            this.businessGroupForm.project_stages.splice(index, 1)
            if (stage.tasks.length) {
                stage.tasks.forEach(field => {
                    if (field.is_system === 1) {
                        this.$set(this.systemTaskList.find(item => item.field_key === field.field_key), 'drag_disabled', false)
                    } else {
                        this.$set(this.customTaskList.find(item => item.field_key === field.field_key), 'drag_disabled', false)
                    }
                })
            }
            this.hasEdit = true
        },

        //点击阶段名称事件
        handleClickStageTitle(item, index) {
            if (item.hasOwnProperty('stage_title_edit')) {
                item.stage_title_edit = !item.stage_title_edit
            } else {
                this.$set(item, 'stage_title_edit', true)
            }
            if (item.stage_title_edit) {
                this.$nextTick(() => {
                    this.$refs[`stage_title_input_${index}`][0].focus()
                })
            }
        },

        //阶段名称输入框回车事件
        handleEnterStageTitleInput(index) {
            this.$refs[`stage_title_input_${index}`][0].blur()
        },

        //阶段名称输入框失焦事件
        handleStageTitleInputBlur(item, index) {
            if (item.name.trim() === '') {
                this.$message.error('请输入阶段名称')
                this.$refs[`stage_title_input_${index}`][0].focus()
            } else {
                item.stage_title_edit = false
                this.hasEdit = true
            }
        },

        //点击删除阶段任务
        handleClickDelStageTask(stage, field) {
            stage.tasks = stage.tasks.filter(item => item.field_key !== field.field_key)
            if (field.is_system === 1) {
                this.$set(this.systemTaskList.find(item => item.field_key === field.field_key), 'drag_disabled', false)
            } else {
                this.$set(this.customTaskList.find(item => item.field_key === field.field_key), 'drag_disabled', false)
            }
            this.hasEdit = true
        },

        onTaskFiledDragMove(e) {
            this.businessGroupForm.project_stages.forEach((item, index) => {
                this.$refs[`stage_task_drag_wrap_${index}`][0].$el.style.backgroundColor = '#ffffff'
            })
            if (e.to.className.includes('stage_task_drag_wrap')) {
                e.to.style.background = 'rgba(0, 0, 0, 0.04)'
            }
        },

        //拖拽字段结束事件
        onTaskFiledDragEnd(e) {
            if (e.clone.dataset.from && e.to.className === 'stage_task_drag_wrap') {
                if (e.clone.dataset.from === 'system') {
                    this.$set(this.systemTaskList[e.oldIndex], 'drag_disabled', true)
                } else if (e.clone.dataset.from === 'custom') {
                    this.$set(this.customTaskList[e.oldIndex], 'drag_disabled', true)
                }
                e.to.style.background = '#ffffff'
                this.hasEdit = true
            }
        },

        //预览
        handleClickStagePreview() {
            if (this.businessGroupForm.project_stages.some(item => item.name.trim() === '')) return this.$message.error('请输入阶段名称')
            this.reviewDetailDialog = true
            this.currentStage = 0
            this.stageTaskFieldList = this.businessGroupForm.project_stages[this.currentStage].tasks
        },

        //关闭预览
        handleClickCloseReviewFormDialog() {
            this.reviewDetailDialog = false
            this.reviewFormType = 'pc'
        },

        //切换预览表单类型
        handleClickReviewFormType(item) {
            this.reviewFormType = item.value
            this.currentStage = 0
            this.stageTaskFieldList = this.businessGroupForm.project_stages[this.currentStage].tasks
        },

        //点击某个阶段
        handleClickStageItem(item, index) {
            this.$msgbox({
                title: '推进至该阶段？',
                message: `是否直接跳转至【${item.name}】阶段！`,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                this.currentStage = index
                this.stageTaskFieldFormShow = false
                this.stageTaskFieldList = item.tasks
                this.$nextTick(() => {
                    this.stageTaskFieldFormShow = true
                })
            }).catch(() => {

            })
        },

        //推进下一阶段
        handleClickAdvanceNextStage() {
            if (this.currentStage < this.businessGroupForm.project_stages.length - 1) {
                this.currentStage++
                this.stageTaskFieldFormShow = false
                this.stageTaskFieldList = this.businessGroupForm.project_stages[this.currentStage].tasks
                this.$nextTick(() => {
                    this.stageTaskFieldFormShow = true
                })
            }
        },

        //点击结束节点
        handleClickBusinessStageEnd() {
            this.$message.warning('预览模式下不支持此操作')
        },

        //发布
        handleClickStagePublish() {
            if (this.businessGroupForm.project_stages.some(item => item.name.trim() === '')) return this.$message.error('请输入阶段名称')
            this.btnDisabled = true
            const data = {
                name: this.businessGroupForm.name,
                applicable_rules: this.businessGroupForm.applicable_rules,
                project_stages: this.businessGroupForm.project_stages.map(item => {
                    return {
                        name: item.name,
                        project_stage_id: item.project_stage_id,
                        tasks: item.tasks.map(task => {
                            return {
                                field_key: task.field_key,
                                is_required: task.is_required,
                            }
                        })
                    }
                })
            }
            if (this.businessGroupForm.project_group_id) {
                data.project_group_id = this.businessGroupForm.project_group_id
                projectGroupEdit(data).then(res => {
                    if (res.code === 200) {
                        this.$message.success('编辑成功')
                        this.$router.replace({
                            name: 'BusinessManagement',
                            params: {
                                from: 'set'
                            }
                        })
                        EventBus.$emit('stageSiteUpdated');
                    } else {

                        this.btnDisabled = false
                    }
                })
            } else {
                projectGroupAdd(data).then(res => {
                    if (res.code === 200) {
                        this.$message.success('发布成功')
                        this.$router.replace({
                            name: 'BusinessManagement',
                            params: {
                                from: 'set'
                            }
                        })
                        EventBus.$emit('stageSiteUpdated');
                    } else {
                        this.btnDisabled = false
                    }
                })
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.business_flow_form_board {
    width: 100%;
    height: 100%;
    background: #F7F8FA;
    padding: 4px 0;

    .business_flow_form_wrap {
        width: fit-content;
        min-width: 560px;
        height: 100%;
        margin: 0 auto;
        background-color: #FFFFFF;
        display: flex;
        flex-direction: column;
        border-radius: 8px;

        ::v-deep .el-form {
            padding: 24px 24px 0;
            flex: 1;
            height: calc(100% - 52px);
            overflow-y: auto;
            overflow-x: hidden;

            .el-form-item__label {
                width: 100%;
            }

            .boolean_select {
                margin-right: 0;
            }

            .flow_rules_list {

                .flow_rules_item {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 8px;
                    margin-bottom: 12px;

                    .rule_field_wrap {
                        min-width: 220px;

                        .el-select {
                            width: 100%;
                        }
                    }

                    .rule_value_wrap {
                        flex: 1;

                        .el-select {
                            width: 100%;
                        }

                        .el-date-editor {
                            width: 330px;

                            .el-range-separator {
                                padding: 0;
                            }
                        }
                    }
                }
            }

            .default_hint {
                font-size: 12px;
                line-height: 18px;
                color: #999999;
            }

            .add_condition_btn {
                border-radius: 4px;
                border: 1px dashed #2990FF;
                text-align: center;
                padding: 5px 0;
                cursor: pointer;
                line-height: 22px;
                color: #2990FF;

                .el-icon-plus {
                    margin-right: 8px;
                }
            }
        }

        .business_flow_btn_wrap {
            padding: 10px 0;
            text-align: center;
            box-shadow: 0px -1px 0px rgba(0, 0, 0, 0.08);
        }
    }
}

.stage_task_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    .left_task_field_wrap {
        width: 340px;
        height: 100%;
        border-radius: 0 0 0 8px;
        box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08);
        padding: 16px;

        .stage_task_field_wrap {
            width: 100%;
            height: calc(100% - 46px);
            overflow-y: auto;
            overflow-x: hidden;

            h3 {
                font-size: 14px;
                font-weight: 700;
                line-height: 22px;
                color: #333333;
            }

            .stage_task_field_list {
                margin: 12px 0;
                width: 100%;

                .chosen {
                    border-color: #2990FF;
                }

                .stage_task_field_item {
                    width: 100%;
                    padding: 5px 12px;
                    border-radius: 4px;
                    border: 1px solid #E8E8E8;
                    line-height: 22px;
                    margin-bottom: 12px;
                    cursor: pointer;

                    &:hover {
                        border-color: #2990FF;
                    }

                    &.drag_disabled {
                        background-color: rgba(0, 0, 0, 0.04);
                        cursor: not-allowed;

                        &:hover {
                            border-color: transparent;
                        }
                    }

                    .field_name {
                        line-height: 22px;
                    }

                    .tasks_desc {
                        line-height: 18px;
                        color: #999999;
                        font-size: 12px;
                        margin-top: 4px;
                    }
                }
            }
        }
    }

    .right_stage_review_wrap {
        flex: 1;
        height: 100%;
        padding: 16px 24px;
        min-width: 666px;
        overflow: hidden;
        position: relative;

        .stage_list {
            width: 100%;
            max-width: 100%;
            height: calc(100% - 62px);
            overflow-y: hidden;
            overflow-x: auto;
            margin-top: 16px;
            border-radius: 6px;

            .stage_list_drag_wrap {
                display: flex;
                height: 100%;
                border-radius: 6px;

                .stage_item {
                    min-width: 252px;
                    height: 100%;
                    cursor: pointer;

                    &:first-child {
                        .stage_task_list {
                            border-left: 1px solid #E8E8E8;
                        }
                    }

                    &:nth-last-child(2) {
                        .stage_title_wrap {
                            &::after {
                                display: none;
                            }

                            &::before {
                                display: none;
                            }
                        }

                        .stage_task_list {
                            border-right: none;
                        }
                    }

                    .stage_title_wrap {
                        padding: 6px 0 6px 16px;
                        text-align: center;
                        background: #EDF0F4;
                        border: 1px solid #E8E8E8;
                        border-right: none;
                        box-sizing: border-box;
                        height: 38px;
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        justify-content: space-between;
                        position: relative;

                        &::after {
                            width: 16px;
                            height: 38px;
                            content: '';
                            background-color: #E8E8E8;
                            position: absolute;
                            right: -15px;
                            top: 0;
                            z-index: 10;
                            clip-path: polygon(0 0, 0 0, 100% 50%, 0 100%, 0 0);
                        }

                        &::before {
                            width: 16px;
                            height: 38px;
                            content: '';
                            background-color: #EDF0F4;
                            position: absolute;
                            right: -13px;
                            top: 0;
                            z-index: 11;
                            clip-path: polygon(0 0, 0 0, 100% 50%, 0 100%, 0 0);
                        }

                        .stage_title {
                            width: 180px;
                            cursor: pointer;
                            line-height: 22px;
                            margin: 0 auto;
                            border-radius: 4px;
                            color: #333333;
                            font-weight: bold;

                            &:hover {
                                background-color: rgba(0, 0, 0, 0.04);
                            }
                        }

                        ::v-deep .el-input {
                            width: 180px;
                            height: 22px;

                            .el-input__inner {
                                border: none;
                                background-color: #EDF0F4;
                                padding: 0;
                                font-size: 14px;
                                line-height: 22px;
                                height: 22px;
                                text-align: center;

                                &:hover {
                                    background-color: rgba(0, 0, 0, 0.04);
                                }
                            }
                        }

                        .stage_handle_icon_wrap {
                            z-index: 20;
                            display: flex;
                            gap: 4px;

                            .el-icon-circle-plus {
                                color: #2990FF;
                            }

                            .el-icon-remove {
                                color: #E44144;
                            }
                        }
                    }

                    .stage_task_list {
                        width: 100%;
                        height: calc(100% - 38px);
                        border-right: 1px solid #E8E8E8;
                        border-bottom: 1px solid #E8E8E8;
                        padding: 4px;
                        overflow-y: auto;
                        overflow-x: hidden;

                        .stage_task_drag_wrap {
                            height: 100%;
                            padding: 8px;
                            position: relative;

                            &.stage_task_drag_move {
                                background-color: rgba(0, 0, 0, 0.12);
                            }

                            .stage_empty_wrap {
                                width: 120px;
                                position: absolute;
                                left: 50%;
                                top: 50%;
                                transform: translate(-50%, -50%);
                                text-align: center;

                                p {
                                    font-size: 12px;
                                    font-weight: 400;
                                    line-height: 18px;
                                    color: #999999;
                                    margin-top: 8px;
                                }
                            }
                        }

                        .stage_task_item {
                            padding: 5px 12px;
                            border-radius: 4px;
                            border: 1px solid #E8E8E8;
                            line-height: 22px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom: 10px;
                            gap: 4px;
                            position: relative;

                            .field_name {
                                flex: 1;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }

                            .el-icon-remove {
                                position: absolute;
                                right: -8px;
                                top: -8px;
                                cursor: pointer;
                                color: #BFBFBF;
                                font-size: 16px;
                            }
                        }
                    }
                }

                .last_empty_item {
                    position: sticky;
                    right: 0;
                    z-index: 50;

                    .top {
                        width: 8px;
                        height: 38px;
                        background-color: #EDF0F4;
                        box-shadow: -2px 0px 4px -2px rgba(0, 0, 0, 0.08);
                        border-right: 1px solid #E8E8E8;
                        border-bottom: 1px solid #E8E8E8;
                    }

                    .bottom {
                        width: 8px;
                        height: calc(100% - 38px);
                        border-radius: 0 0 5px 0;
                        background: #FFFFFF;
                        box-shadow: -2px 0px 4px -2px rgba(0, 0, 0, 0.08);
                        border-right: 1px solid #E8E8E8;
                        border-bottom: 1px solid #E8E8E8;
                    }
                }
            }
        }
    }

    h2 {
        font-weight: 700;
        line-height: 24px;
        margin-bottom: 4px;
        font-size: 16px;
    }

    .title_desc {
        font-size: 12px;
        line-height: 18px;
        color: #666666;
    }
}

.review_form_wrap {
    position: relative;
    width: 100%;
    height: 736px;
    display: flex;
    flex-direction: column;

    .el-icon-close {
        position: absolute;
        right: -10px;
        top: -10px;
        cursor: pointer;
        font-size: 16px;
        color: #666666;
    }

    .review_form_type_list {
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 100px;

        .review_form_type_item {
            width: 238px;
            text-align: center;
            padding: 8px 0;
            line-height: 22px;
            color: #666666;
            background-color: #EDF0F4;
            cursor: pointer;

            &:first-child {
                border-radius: 6px 0 0 6px;
            }

            &:last-child {
                border-radius: 0 6px 6px 0;
            }

            &.active {
                background-color: #2990FF;
                color: #FFFFFF;
                font-weight: bold;
                border-radius: 6px;
            }
        }
    }

    .pc_review_wrap {
        flex: 1;
        padding: 16px;
        margin-top: 30px;
        box-shadow: 0 2px 6px 2px rgba(0, 0, 0, 0.12);
        border-radius: 8px;

        .business_stage_detail {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            overflow: hidden;

            .business_stage_wrap {
                display: flex;
                align-items: center;
                gap: 12px;
                margin-bottom: 24px;
                border-bottom: 1px solid #E8E8E8;

                .business_stage_list {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    gap: 22px;
                    border-radius: 6px;
                    overflow-x: auto;
                    scrollbar-width: none; /* Firefox 中隐藏 */
                    -ms-overflow-style: none; /* 旧版 IE */

                    &::-webkit-scrollbar {
                        display: none; /* 隐藏滚动条 */
                    }

                    .business_stage_item {
                        padding: 6px 12px;
                        min-width: 110px;
                        text-align: center;
                        cursor: pointer;
                        position: relative;
                        display: flex;
                        gap: 8px;
                        align-items: center;

                        .stage_index {
                            width: 22px;
                            height: 22px;
                            font-size: 12px;
                            line-height: 20px;
                            border: 1px solid #D9D9D9;
                            border-radius: 50%;
                            text-align: center;
                            vertical-align: middle;
                            color: #999999;
                        }

                        .stage_title {
                            line-height: 22px;
                            color: #666666;
                            flex: 1;
                            white-space: nowrap;
                        }

                        .el-icon-arrow-right {
                            font-size: 12px;
                            color: #666666;
                            position: absolute;
                            right: -17px;
                        }

                        &.excessive_current_stage {
                            font-weight: bold;
                            color: #333333;

                            .stage_index {
                                color: #FFFFFF;
                                background-color: #2990FF;
                            }

                            .stage_title {
                                color: #333333;
                            }

                            &::before {
                                background-color: #2990FF;
                            }
                        }

                        &.current_stage {
                            border-bottom: 2px solid #2990FF;
                        }
                    }

                    ::v-deep .el-dropdown {
                        position: sticky;
                        right: 0;
                    }

                    .business_end_stage {
                        z-index: 10;
                        background-color: #FFFFFF;
                        box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08), -2px 0px 4px -2px rgba(0, 0, 0, 0.08);
                    }
                }

                ::v-deep .el-button {
                    padding: 2px 8px;
                    line-height: 18px;
                    border-radius: 4px;
                }
            }

            .stage_task_form_wrap {
                flex: 1;
                overflow-y: auto;
                overflow-x: hidden;

                .no_task_hint {
                    text-align: center;
                }
            }
        }
    }

    .mobile_review_outer_wrap {
        flex: 1;
        width: 391px;
        height: 640px;
        opacity: 1;
        border-radius: 30px;
        background: rgb(255, 255, 255);
        box-shadow: 0 2px 6px 2px rgba(0, 0, 0, 0.12);
        margin: 30px auto 0;
        padding: 8px;

        .mobile_review_inner_wrap {
            width: 100%;
            height: 100%;
            border-radius: 30px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            position: relative;

            .business_stage_detail {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                overflow: hidden;

                .review_form_title {
                    padding: 6px 16px;
                    line-height: 28px;
                    font-family: 思源黑体;
                    border-bottom: 1px solid #F7F8FA;

                    .el-icon-arrow-left {
                        color: #666666;
                        cursor: pointer;
                        margin-right: 10px;
                        font-size: 16px;
                    }

                    span {
                        font-size: 18px;
                        font-weight: 700;
                        line-height: 32px;
                        color: #333333;
                    }
                }

                .business_stage_list_wrap {
                    padding: 16px;

                    .business_stage_list {
                        display: flex;
                        overflow-x: auto;
                        scrollbar-width: none; /* Firefox 中隐藏 */
                        -ms-overflow-style: none; /* 旧版 IE */

                        .business_stage_item {
                            min-width: 50px;
                            height: 24px;
                            background-color: #EDF0F4;
                            cursor: pointer;
                            text-align: center;
                            position: relative;
                            line-height: 22px;
                            color: #999999;
                            padding-left: 5px;

                            &:first-child {
                                border-radius: 4px 0 0 4px;
                            }

                            &:last-child {
                                border-radius: 0 4px 4px 0;

                                &::after {
                                    display: none;
                                }

                                &::before {
                                    display: none;
                                }
                            }

                            &.current_stage {
                                background-color: #2990FF;
                                color: #FFFFFF;

                                &::before {
                                    background-color: #2990FF;
                                }
                            }

                            &::before {
                                width: 10px;
                                height: 24px;
                                content: '';
                                background-color: #EDF0F4;
                                position: absolute;
                                right: -10px;
                                top: 0;
                                z-index: 11;
                                clip-path: polygon(0 0, 0 0, 100% 50%, 0 100%, 0 0);
                            }

                            &::after {
                                width: 10px;
                                height: 24px;
                                content: '';
                                background-color: #FFFFFF;
                                position: absolute;
                                right: -12px;
                                top: 0;
                                z-index: 10;
                                clip-path: polygon(0 0, 0 0, 100% 50%, 0 100%, 0 0);
                            }
                        }
                    }
                }

                .business_stage_wrap {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 16px;

                    .current_stage_index {
                        font-size: 16px;
                        color: #333333;
                        font-weight: bold;
                        line-height: 24px;
                    }

                    .stage_list_length {
                        color: #666666;
                        font-size: 12px;
                        line-height: 24px;
                        font-weight: bold;
                    }

                    .current_stage_title {
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 24px;
                        color: #333333;
                        margin-left: 4px;
                    }

                    .el-button {
                        padding: 5px 8px;
                        border-radius: 4px;
                    }
                }

                .title_wrap {
                    padding: 16px 16px 0;

                    .page_little_title {
                        margin-bottom: 0;
                    }
                }

                .stage_task_form_wrap {
                    flex: 1;
                    max-height: calc(100% - 167px);
                    border-radius: 0 0 30px 30px;
                }
            }

            .mobile_handle_line {
                position: absolute;
                bottom: 10px;
                left: 50%;
                transform: translateX(-50%);
                width: 134px;
                height: 4px;
                border-radius: 10px;
                background-color: #000000;
            }

            .no_task_hint {
                text-align: center;
            }
        }
    }

    .form_desc {
        text-align: center;
        font-size: 12px;
        line-height: 18px;
        color: #999999;
        margin-top: 16px;
    }
}
</style>
<style lang="scss">
.review_form_dialog .el-dialog__body {
    padding: 32px 60px 60px;
}

.el-dropdown-menu .el-dropdown-menu__item:hover {
    background: rgba(41, 144, 255, 0.08);
    color: #2990FF;
}
</style>